import { INITIAL_ARCHIVED_PROJECT_STATE } from '../../../utils/state';
import { ArchivedCurrentProjectActionType } from '../../actionTypes/archivedCurrentProject';
import { GET_ARCHIVED_PROJECT } from '../../actions/types';
import { PostDispatch, ArchivedProject } from '../../types';

const reducer = (
    state = INITIAL_ARCHIVED_PROJECT_STATE,
    action: PostDispatch
): ArchivedProject => {
    switch (action.type) {
        case GET_ARCHIVED_PROJECT:
            return action.payload as ArchivedProject;
        case ArchivedCurrentProjectActionType.RESET_PROJECT:
            return INITIAL_ARCHIVED_PROJECT_STATE;
        default:
            return state;
    }
};
export default reducer;
